import { Launch } from '@mui/icons-material';
import useAppTheme from 'hooks/useAppTheme';
import type { Asset } from 'types/asset.types';

interface Props {
  asset: Asset;
  handleAssetSelected: (assetId: string) => void;
  hasDTC?: boolean;
}

export function LaunchCompareModal({
  asset,
  handleAssetSelected,
  hasDTC,
}: Props) {
  const { enableDarkTheme } = useAppTheme();
  const { assetId } = asset;

  return (
    <Launch
      sx={{
        position: 'absolute',
        right: '5px',
        top: hasDTC ? '35px' : '5px',
        color: enableDarkTheme ? '#fff' : '#000',
        cursor: 'pointer',
      }}
      onClick={() => {
        handleAssetSelected(assetId);
      }}
    />
  );
}

export default LaunchCompareModal;
